import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ErrorHandler } from '../../common/errorHandler';
import { QuestionGroupService } from '../../services/question.group.service';
import { QuestionGroup } from '../../models/question.group.model';
import { ResultCode } from '../../enums/resultcode.enum';
import { AccessRight } from '../../enums/access.right.enum';
import { QuestionType } from '../../enums/question.type.enum';

@Component({
    selector: 'questiongroup-detail',
    templateUrl: './questiongroup-detail.component.html',
    styleUrls: ['./questiongroup-detail.component.css'],
    providers: [QuestionGroupService, ErrorHandler]
})
export class QuestionGroupDetailComponent implements OnInit {
    questionGroup: QuestionGroup;
    isDataAvailable = false;
    messages: Array<string>;
    accessRights: Array<AccessRight>;
    questionTypes: Array<QuestionType>;
    private groupId: string;

    constructor(
        private questionGroupService: QuestionGroupService,
        private errorHandler: ErrorHandler,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.questionGroup = new QuestionGroup();
        this.accessRights = new Array<AccessRight>();
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.accessRights = [];
            this.accessRights.push(AccessRight.reader);
            this.accessRights.push(AccessRight.writer);
            this.accessRights.push(AccessRight.author);
            this.accessRights.push(AccessRight.admin);

            this.questionTypes = [];
            this.questionTypes.push(QuestionType.cityImage);
            this.questionTypes.push(QuestionType.vocabulary);
            this.questionTypes.push(QuestionType.other);

            if (params['questionGroupId'] && params['questionGroupId'] !== '0') {
                this.questionGroupService.getQuestionGroup(params['questionGroupId'])
                    .then(questionGroup => {
                            this.questionGroup = questionGroup;
                            this.isDataAvailable = true;
                        }
                    )
                    .catch(error => {
                        this.errorHandler.do(error);
                    });
                } else {
                    this.isDataAvailable = true;
                }
        });
    }

    save(): void {
        if (this.questionGroup.id === undefined) {
            this.insert();
        } else {
            this.update();
        }
    }

    private update(): void {
        this.isDataAvailable = false;
        this.questionGroupService.updateQuestionGroup(this.questionGroup)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['questiongroups']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    private insert(): void {
        this.isDataAvailable = false;
        this.questionGroupService.addQuestionGroup(this.questionGroup)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['questiongroups']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    cancel(): void {
        this.router.navigate(['questiongroups']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/questiongroup-detail/questiongroup-detail.component.ts